module.exports = __webpack_public_path__ + "img/引导.ca1a7354.png";